export const CountChip = ({ count }) => (
	<span className="ml-2 px-2 py-0.5 text-xs font-medium bg-[var(--color-bg-primary)] text-[var(--color-text-secondary)] rounded-full">
		{count}
	</span>
);
